import * as $req from 'react-reqq-simulate';

import * as c from './constant';

export const getAdminProfile = () => {
  $req.get({
    key: c.GET_ADMIN_PROFILE,
    transform: () => ({
      full_name: 'PEP Administrator',
    }),
    duration: 1000,
  });
};
